"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _loading = require("./loading.styles");

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _jsxRuntime = require("react/jsx-runtime");

const Spinner = ({
  children,
  size,
  color,
  textColor,
  className,
  ...props
}) => {
  const isValidChildren = Array.isArray(children) ? (children == null ? void 0 : children.length) > 1 && children[0] !== undefined : children !== undefined;
  const ariaLabel = children && isValidChildren ? '' : 'Loading';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_loading.StyledSpinner, {
    className: (0, _clsx.default)('nextui-spinner', className),
    color: color,
    size: size,
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_loading.StyledSpinnerContainer, {
      className: "nextui-spinner-container",
      "aria-label": ariaLabel,
      children: [...new Array(12)].map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_loading.StyledSpinnerSpan, {}, `nextui-spinner-${index}`))
    }), children && /*#__PURE__*/(0, _jsxRuntime.jsx)(_loading.StyledLoadingLabel, {
      size: size,
      color: textColor,
      children: children
    })]
  });
};

Spinner.toString = () => '.nextui-spinner';

var _default = Spinner;
exports.default = _default;
module.exports = exports.default;